import { UnprotectedRouteResponsiveCard } from "@eisox/design-system";
import { useAppForm } from "@eisox/form";
import { useMutation } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";

import { accountApi } from "~/api";
import { emailSchema } from "~/features/account";
import { m } from "~/paraglide/messages";

export const Route = createFileRoute("/recover-account")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();

  const { mutateAsync: recoverAccount } = useMutation({
    meta: { toast: { success: m.account_email_sent() } },
    mutationFn: (email: string) => accountApi.requestPasswordReset(email),
    onSuccess: async () => {
      await navigate({ to: "/sign-in", search: { redirect: "" } });
    },
  });

  const form = useAppForm({
    defaultValues: {
      email: "",
    },
    validators: {
      onSubmit: emailSchema,
    },
    onSubmit: ({ value }) => recoverAccount(value.email),
  });

  return (
    <UnprotectedRouteResponsiveCard version={import.meta.env.VITE_VERSION}>
      <form
        className="gap-10 md:w-[429px] flex flex-col items-center justify-center"
        data-testid="RecoverAccount"
        onSubmit={e => {
          e.preventDefault();
          void form.handleSubmit();
        }}
      >
        <form.AppForm>
          <form.AppField name="email">
            {field => (
              <field.TextField
                classNames={{ control: "w-full" }}
                label={m.recover_account_label()}
                placeholder={m.email_placeholder()}
              />
            )}
          </form.AppField>
          <form.SubmitButton label={m.send_link()} />
          <Link to="/sign-in" search={{ redirect: "" }} className="text-base whitespace-normal text-primary-dark-gray">
            Revenir à l'écran de connexion
          </Link>
        </form.AppForm>
      </form>
    </UnprotectedRouteResponsiveCard>
  );
}
